import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import CSRPage from './pages/CSRPage';
import EquipmentPage from './pages/EquipmentPage';
import './App.css';

export default function App() {
  return <BrowserRouter>
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/csr-partnerships" element={<CSRPage />} />
        <Route path="/medical-equipment-solutions" element={<EquipmentPage />} />
      </Routes>
    </Layout>
  </BrowserRouter>;
}
